export default __webpack_public_path__ + "static/media/complaint.950f63e9.svg";